/** DOB is a calendar date, including when the API serializes it at midnight UTC. */
export const formatDateOfBirth = (value?: string | null): string => {
  if (!value) return '—';
  const match = /^(\d{4})-(\d{2})-(\d{2})(?:T|$)/.exec(value);
  if (!match) return '—';
  const date = new Date(`${match[1]}-${match[2]}-${match[3]}T00:00:00.000Z`);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== match[0].slice(0, 10)) return '—';
  return date.toLocaleDateString(undefined, { timeZone: 'UTC' });
};
